import React from "react"
import styles from "./Number.module.css"

const Number = ({ number, extra }) => <div className={extra?styles.extraNumber:styles.number}>{number}</div>
export default Number
